import React from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function OfferAcceptanceModal({
  open,
  onClose,
  onSubmit,
  acceptanceRegister,
  offerAcceptanceStatus,
  errors,
  loading,
}) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity"
      />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="max-w-2xl w-full space-y-4 border bg-white rounded-lg">
          <div className="p-8">
            <DialogTitle className="text-xl uppercase pb-4">
              Offer Acceptance
            </DialogTitle>
            <form onSubmit={onSubmit}>
              <div className="mt-6 grid lg:grid-cols-2 gap-x-6">
                <div className="form-field">
                  <label
                    htmlFor="offerAcceptanceStatus"
                    className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                  >
                    Status
                  </label>
                  <select
                    id="offerAcceptanceStatus"
                    {...acceptanceRegister("offerAcceptanceStatus")}
                    className="bg-gray-50 border border-gray-300 text-md rounded-md form-select appearance-none bg-no-repeat text-gray-900 w-full p-2"
                  >
                    <option value="">No</option>
                    <option value="Committed">
                      I have made a verbal commitment
                    </option>
                    <option value="Signed">
                      I have signed a letter of intent
                    </option>
                  </select>
                </div>
                <div className="form-field">
                  <label
                    htmlFor="offerAcceptanceSchool"
                    className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                  >
                    School
                  </label>
                  <input
                    type="text"
                    id="offerAcceptanceSchool"
                    placeholder="School name"
                    disabled={offerAcceptanceStatus === ""}
                    {...acceptanceRegister("offerAcceptanceSchool", {
                      validate: (v) =>
                        offerAcceptanceStatus === "" ||
                        !!v?.trim() ||
                        "School is required",
                    })}
                    className={`appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 leading-tight focus:outline-none focus:bg-white${
                      offerAcceptanceStatus === ""
                        ? " opacity-50 cursor-not-allowed"
                        : ""
                    }`}
                  />
                  {errors.offerAcceptanceSchool && (
                    <span className="text-red-500 text-sm">
                      {errors.offerAcceptanceSchool.message}
                    </span>
                  )}
                </div>
              </div>
              <div className="form-field mt-4">
                {loading && <LoadingSpinner />}
              </div>
              <div className="flex gap-4 bg-gray-50 sm:flex sm:flex-row-reverse p-4 mt-4">
                <button
                  type="submit"
                  className="bg-red-500 text-white p-3 px-10 rounded-md uppercase text-sm hover:bg-red-700 ml-3"
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={onClose}
                  className="text-gray-600 font-semibold hover:text-gray-800"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
